import style from "./CustomIcon.module.css";
import { ReactComponent as HomeIcon } from "resources/img/icons/home.svg";
import { ReactComponent as ShoppingBagIcon } from "resources/img/icons/shoppingbag.svg";
import { ReactComponent as MessageIcon } from "resources/img/icons/message.svg";
import { ReactComponent as TagIcon } from "resources/img/icons/tag.svg";
import { ReactComponent as CartIcon } from "resources/img/icons/cart.svg";
import { ReactComponent as ProfileIcon } from "resources/img/icons/mypage/user.svg";
import { ReactComponent as HeartIcon } from "resources/img/icons/heart.svg";
import { ReactComponent as MenuIcon } from "resources/img/icons/footer/menu.svg";
import { ReactComponent as SearchIcon } from "resources/img/icons/footer/search.svg";
import OrderList from "resources/img/icons/admin/png/주문현황.png";
import QuestionIcon from "resources/img/icons/admin/png/자주-묻는-질문.png";
import ProductManagementIcon from "resources/img/icons/admin/png/상품관리.png";
import DesignIcon from "resources/img/icons/admin/png/디자인-메뉴얼.png";
import SettingIcon from "resources/img/icons/admin/png/설정-메뉴얼.png";
import { ReactComponent as RightIcon } from "resources/img/icons/admin/화살표.svg";
import NoticeIcon from "resources/img/icons/admin/png/공지.png";
import { ReactComponent as ArticleIcon } from "resources/img/icons/admin/게시판.svg";
import QnaIcon from "resources/img/icons/admin/png/qna.png";
import ReviewIcon from "resources/img/icons/admin/png/리뷰.png";
import MoveIcon from "resources/img/icons/admin/png/이동.png";
import articleStatus from "resources/img/icons/admin/png/게시물-현황.png";
import ExchangeAndRefundIcon from "resources/img/icons/admin/png/교환-및-환불현황.png";
import DelayIcon from "resources/img/icons/admin/png/처리지연.png";
import WatingIcon from "resources/img/icons/admin/png/입금대기.png";
import PreparingProductIcon from "resources/img/icons/admin/png/상품준비.png";
import WaitingForDeliveryIcon from "resources/img/icons/admin/png/배송대기.png";
import ShippingIcon from "resources/img/icons/admin/png/배송중.png";
import CourierInterlockingIcon from "resources/img/icons/admin/png/택배연동.png";
import DirectDepositIcon from "resources/img/icons/admin/png/자동입금확인.png";
import MainProductManagementIcon from "resources/img/icons/admin/png/product/메인상품관리.png";
import MainItemsOnShowIcon from "resources/img/icons/admin/png/product/메인진열상품.png";
import ProductNotShownIcon from "resources/img/icons/admin/png/product/미진열상품.png";
import ProductManagement2Icon from "resources/img/icons/admin/png/product/상품관리.png";
import ProductRegisterIcon from "resources/img/icons/admin/png/product/상품등록.png";
import ProductOptionIcon from "resources/img/icons/admin/png/product/상품옵션.png";
import InventoryControlIcon from "resources/img/icons/admin/png/product/재고관리.png";
import AllProductIcon from "resources/img/icons/admin/png/product/전체상품.png";
import CategoryIcon from "resources/img/icons/admin/png/product/카테고리.png";
import ProductsOnSaleIcon from "resources/img/icons/admin/png/product/판매중상품.png";
import SoldOutProductIcon from "resources/img/icons/admin/png/product/품절상품.png";
import OutOfStockIcon from "resources/img/icons/admin/png/product/품절임박+관리필요.png";
import CurrentMonthNewUserIcon from "resources/img/icons/admin/png/user/당월-신규가입.png";
import CurrentMonthWithdrawalUserIcon from "resources/img/icons/admin/png/user/당월-탈퇴회원.png";
import TodayNewUserIcon from "resources/img/icons/admin/png/user/당일-신규가입.png";
import DepositIcon from "resources/img/icons/admin/png/user/예치금.png";
import TodayVisitorIcon from "resources/img/icons/admin/png/user/일일-방문자.png";
import ReservesIcon from "resources/img/icons/admin/png/user/적립금.png";
import UserManagementIcon from "resources/img/icons/admin/png/user/회원관리.png";
import MemberInformationInquiryIcon from "resources/img/icons/admin/png/user/회원정보조회.png";
import ArticleOperStatusIcon from "resources/img/icons/admin/png/article/운영현황.png";
import ArticleCapacityIcon from "resources/img/icons/admin/png/article/용량현황.png";
import LatestArticlesIcon from "resources/img/icons/admin/png/article/최신글.png";
import ArticleManagementIcon from "resources/img/icons/admin/png/article/게시판-관리.png";
import PostManagementIcon from "resources/img/icons/admin/png/article/게시글-관리.png";
import EventsInProgressIcon from "resources/img/icons/admin/png/promotion/진행-중-이벤트.png";
import CouponStatusIcon from "resources/img/icons/admin/png/promotion/쿠폰.png";
import DeleteIcon from "resources/img/icons/admin/png/promotion/휴지통.png";
import ManagementIcon from "resources/img/icons/admin/png/promotion/관리.png";
import EventManagementIcon from "resources/img/icons/admin/png/promotion/이벤트-관리.png";
import CouponManagementIcon from "resources/img/icons/admin/png/promotion/쿠폰관리.png";
import DownIcon from "resources/img/icons/admin/png/promotion/앵글.png";
import StatisticsCartIcon from "resources/img/icons/admin/png/statistics/장바구니.png";
import StatisticsSalesIcon from "resources/img/icons/admin/png/statistics/판매량순위.png";
import StatisticsIcon from "resources/img/icons/admin/png/statistics/매출통계.png";
import ProductStatisticsIcon from "resources/img/icons/admin/png/statistics/상툼통계.png";
import CalendarIcon from "resources/img/icons/admin/달력.png";
import MyPageUserIcon from "resources/img/icons/mypage/user2.png";
import MyPageShippingIcon from "resources/img/icons/mypage/상단_배송조회.png";
import MyPageReviewIcon from "resources/img/icons/mypage/상단_리뷰관리.png";
import MyPagePointIcon from "resources/img/icons/mypage/상단_포인트.png";
import MyPagePaymentIcon from "resources/img/icons/mypage/상단_결제수단.png";
import MyPageListShippingIcon from "resources/img/icons/mypage/배송조회관리.png";
import MyPageListExchangeIcon from "resources/img/icons/mypage/교환반품내역.png";
import MyPageListCartIcon from "resources/img/icons/mypage/장바구니.png";
import MyPageListWishlistIcon from "resources/img/icons/mypage/위시리스트.png";
import MyPageListCouponIcon from "resources/img/icons/mypage/이벤트.png";
import MyPageListInquiryIcon from "resources/img/icons/mypage/문의내역.png";
import MyPageListReviewIcon from "resources/img/icons/mypage/리뷰.png";
import MyPageListRestockIcon from "resources/img/icons/mypage/재입고.png";
import MyPageListUserInfoIcon from "resources/img/icons/mypage/계정정보.png";
import MyPageListAddressIcon from "resources/img/icons/mypage/배송지등록.png";
import MyPageListLoginHistoryIcon from "resources/img/icons/mypage/로그인이력.png";
import MyPageListAccountIcon from "resources/img/icons/mypage/계정 비활성화.png";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import { ReactComponent as AllProductImg } from "resources/img/icons/전제상품.svg";
import { ReactComponent as MouthImg } from "resources/img/icons/입호흡.svg";
import { ReactComponent as BreathImg } from "resources/img/icons/폐호흡.svg";
import { ReactComponent as DeviceImg } from "resources/img/icons/기계.svg";
import { ReactComponent as EtcImg } from "resources/img/icons/코일 및 기타용품.svg";
import { ReactComponent as DataImg } from "resources/img/icons/자료실.svg";

function CustomIcon(props) {
  const { name, color, width, notification } = props;

  return (
    <SquareWrapper width={width}>
      {notification && <span className={style.notification}></span>}

      {
        {
          home: (
            <HomeIcon
              className={style.icon}
              fill={"transparent"}
              stroke={color || "black"}
            />
          ),

          shoppingBag: (
            <ShoppingBagIcon className={style.icon} fill={color || "black"} />
          ),
          message: (
            <MessageIcon
              className={style.icon}
              fill={"transparent"}
              stroke={color || "black"}
            />
          ),
          tag: <TagIcon className={style.icon} fill={color || "transparent"} />,
          cart: (
            <CartIcon className={style.icon} fill={color || "transparent"} />
          ),
          profile: (
            <ProfileIcon
              className={style.icon}
              fill={color}
              stroke={color || "black"}
            />
          ),
          heart: (
            <HeartIcon
              className={style.icon}
              fill={"transparent"}
              stroke={color || "black"}
            />
          ),
          heartFill: (
            <HeartIcon
              className={style.icon}
              fill={color || "transparent"}
              stroke={color || "black"}
            />
          ),
          menu: (
            <MenuIcon
              className={style.icon}
              fill={color || "transparent"}
              stroke={color || "black"}
            />
          ),
          search: (
            <SearchIcon
              className={style.icon}
              fill={color || "transparent"}
              stroke={color || "black"}
            />
          ),
          right: (
            <RightIcon
              className={style.icon}
              fill={color || "transparent"}
              stroke={color || "black"}
            />
          ),
          article: (
            <ArticleIcon
              className={style.icon}
              fill={color || "transparent"}
              stroke={color || "black"}
            />
          ),
          waitingForPayment: (
            <img src={WatingIcon} className={style.icon} alt={""} />
          ),
          preparingShipment: (
            <img src={PreparingProductIcon} className={style.icon} alt={""} />
          ),
          readyForShipment: (
            <img src={WaitingForDeliveryIcon} className={style.icon} alt={""} />
          ),
          shipping: <img src={ShippingIcon} className={style.icon} alt={""} />,
          courierInterlocking: (
            <img
              src={CourierInterlockingIcon}
              className={style.icon}
              alt={""}
            />
          ),
          directDeposit: (
            <img src={DirectDepositIcon} className={style.icon} alt={""} />
          ),
          orderList: (
            <img
              src={OrderList}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          question: (
            <img
              src={QuestionIcon}
              className={style.icon}
              alt={""}
              style={{ position: "absolute" }}
            />
          ),
          productManagement: (
            <img
              src={ProductManagementIcon}
              className={style.icon}
              alt={""}
              style={{
                filter: color === "white" ? null : "invert(100%)",
                position: "absolute",
              }}
            />
          ),
          design: <img src={DesignIcon} className={style.icon} alt={""} />,
          setting: <img src={SettingIcon} className={style.icon} alt={""} />,
          notice: <img src={NoticeIcon} className={style.icon} alt={""} />,
          qna: (
            <img
              src={QnaIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          review: <img src={ReviewIcon} className={style.icon} alt={""} />,
          exchangeAndRefund: (
            <img
              src={ExchangeAndRefundIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          delay: (
            <img
              src={DelayIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          move: <img src={MoveIcon} className={style.icon} alt={""} />,
          articleStatus: (
            <img
              src={articleStatus}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          mainProductManagement: (
            <img
              src={MainProductManagementIcon}
              className={style.icon}
              alt={""}
            />
          ),
          mainItemsOnShow: (
            <img
              src={MainItemsOnShowIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          productNotShown: (
            <img
              src={ProductNotShownIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          productManagement2: (
            <img src={ProductManagement2Icon} className={style.icon} alt={""} />
          ),
          productRegister: (
            <img src={ProductRegisterIcon} className={style.icon} alt={""} />
          ),
          productOption: (
            <img src={ProductOptionIcon} className={style.icon} alt={""} />
          ),
          inventoryControl: (
            <img src={InventoryControlIcon} className={style.icon} alt={""} />
          ),
          allProduct: (
            <img
              src={AllProductIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          category: <img src={CategoryIcon} className={style.icon} alt={""} />,
          productsOnSale: (
            <img
              src={ProductsOnSaleIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          soldOutProduct: (
            <img
              src={SoldOutProductIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          outOfStock: (
            <img
              src={OutOfStockIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          currentMonthNewUser: (
            <img
              src={CurrentMonthNewUserIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          currentMonthWithdrawalUser: (
            <img
              src={CurrentMonthWithdrawalUserIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          todayNewUser: (
            <img
              src={TodayNewUserIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          deposit: <img src={DepositIcon} className={style.icon} alt={""} />,
          todayVisitor: (
            <img
              src={TodayVisitorIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          reserves: <img src={ReservesIcon} className={style.icon} alt={""} />,
          userManagement: (
            <img
              src={UserManagementIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          memberInformationInquiry: (
            <img
              src={MemberInformationInquiryIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          articleOperStatus: (
            <img
              src={ArticleOperStatusIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "black" ? "invert(100%)" : null }}
            />
          ),
          articleCapacity: (
            <img
              src={ArticleCapacityIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "black" ? "invert(100%)" : null }}
            />
          ),
          latestArticles: (
            <img
              src={LatestArticlesIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "black" ? "invert(100%)" : null }}
            />
          ),
          articleManagement: (
            <img src={ArticleManagementIcon} className={style.icon} alt={""} />
          ),
          postManagement: (
            <img src={PostManagementIcon} className={style.icon} alt={""} />
          ),
          eventsInProgress: (
            <img
              src={EventsInProgressIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "black" ? "invert(100%)" : null }}
            />
          ),
          couponStatus: (
            <img
              src={CouponStatusIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "black" ? "invert(100%)" : null }}
            />
          ),
          delete: (
            <img
              src={DeleteIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "black" ? "invert(100%)" : null }}
            />
          ),
          management: (
            <img
              src={ManagementIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "black" ? "invert(100%)" : null }}
            />
          ),
          eventManagement: (
            <img src={EventManagementIcon} className={style.icon} alt={""} />
          ),
          couponManagement: (
            <img src={CouponManagementIcon} className={style.icon} alt={""} />
          ),
          downAngle: (
            <img
              src={DownIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          statisticsCart: (
            <img
              src={StatisticsCartIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          statisticsSales: (
            <img
              src={StatisticsSalesIcon}
              className={style.icon}
              alt={""}
              style={{ filter: color === "white" ? "invert(100%)" : null }}
            />
          ),
          statistics: (
            <img src={StatisticsIcon} className={style.icon} alt={""} />
          ),
          productStatistics: (
            <img src={ProductStatisticsIcon} className={style.icon} alt={""} />
          ),
          calendar: <img src={CalendarIcon} className={style.icon} alt={""} />,
          myPageUser: (
            <img src={MyPageUserIcon} className={style.icon} alt={""} />
          ),
          myPageShipping: (
            <img src={MyPageShippingIcon} className={style.icon} alt={""} />
          ),
          myPageReview: (
            <img src={MyPageReviewIcon} className={style.icon} alt={""} />
          ),
          myPagePoint: (
            <img src={MyPagePointIcon} className={style.icon} alt={""} />
          ),
          myPagePayment: (
            <img src={MyPagePaymentIcon} className={style.icon} alt={""} />
          ),
          myPageListShipping: (
            <img src={MyPageListShippingIcon} className={style.icon} alt={""} />
          ),
          myPageListExchange: (
            <img src={MyPageListExchangeIcon} className={style.icon} alt={""} />
          ),
          myPageListCart: (
            <img src={MyPageListCartIcon} className={style.icon} alt={""} />
          ),
          myPageListWishlist: (
            <img src={MyPageListWishlistIcon} className={style.icon} alt={""} />
          ),
          myPageListCoupon: (
            <img src={MyPageListCouponIcon} className={style.icon} alt={""} />
          ),
          myPageListInquiry: (
            <img src={MyPageListInquiryIcon} className={style.icon} alt={""} />
          ),
          myPageListReview: (
            <img src={MyPageListReviewIcon} className={style.icon} alt={""} />
          ),
          myPageListRestock: (
            <img src={MyPageListRestockIcon} className={style.icon} alt={""} />
          ),
          myPageListUserInfo: (
            <img src={MyPageListUserInfoIcon} className={style.icon} alt={""} />
          ),
          myPageListAddress: (
            <img src={MyPageListAddressIcon} className={style.icon} alt={""} />
          ),
          myPageListLoginHistory: (
            <img
              src={MyPageListLoginHistoryIcon}
              className={style.icon}
              alt={""}
            />
          ),
          myPageListAccount: (
            <img src={MyPageListAccountIcon} className={style.icon} alt={""} />
          ),
        }[name]
      }
    </SquareWrapper>
  );
}

export default CustomIcon;
